import { getAuthRequest } from 'Api/api';
import { useState, useEffect } from 'react';

export const useBracketStrengthHook = () => {
  const [bracketName, setBracketName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [sheathingName, setSheathingName] = useState([]);
  const [fastenerName, setFastenerName] = useState([]);
  const [seamName, setSeamName] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const getSnowBracketTypes = async () => {
    try {
      setShowLoader(true);
      const bracketName = await getAuthRequest('getBracketsList');
      const list = bracketName.bracketPricesList;
      setBracketName(list?.map((list) => ({ name: list.name, id: list.bracketId })));
      setShowLoader(false);
    } catch (err) {
      setShowLoader(false);
      return err;
    }
  };

  const getSnowBracketMaterials = async () => {
    try {
      setShowLoader(true);
      const materialName = await getAuthRequest('getSnowBracketMaterials');
      setMaterialName(materialName);
      setShowLoader(false);
    } catch (err) {
      console.log(err);
      setShowLoader(false);
    }
  };

  const getRoofSheathingTypes = async () => {
    try {
      setShowLoader(true);
      const sheathingName = await getAuthRequest('getRoofSheathingTypes');
      setSheathingName(sheathingName);
      setShowLoader(false);
    } catch (err) {
      console.log(err);
      setShowLoader(false);
    }
  };

  const getFastenerTypes = async () => {
    try {
      setShowLoader(true);
      const fastenerName = await getAuthRequest('getFastenerTypes');
      setFastenerName(fastenerName);
      setShowLoader(false);
    } catch (err) {
      console.log(err);
      setShowLoader(false);
    }
  };
  const getSeamTypes = async () => {
    try {
      setShowLoader(true);
      const seamName = await getAuthRequest('getSeamTypes');
      setSeamName(seamName);
      setShowLoader(false);
    } catch (err) {
      console.log(err);
      setShowLoader(false);
    }
  };

  useEffect(() => {
    getSnowBracketTypes();
    getSeamTypes();
    getSnowBracketMaterials();
    getRoofSheathingTypes();
    getFastenerTypes();
  }, []);

  return {
    bracketName,
    seamName,
    materialName,
    sheathingName,
    fastenerName,
    showLoader,
    setShowLoader
  };
};
